export const INITIAL_VALUES = {
  companyNameCredential:""
};

export const validation = (key, intl) => {
  switch (key) {
    case "companyNameCredential":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    default:
      return [];
  }
};
